/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, Event, NavigationStart } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { CommonService } from 'src/app/services/common.service';
import { environment } from '../../../environments/environment';
import { EnvSettingsService } from "src/app/core/services/env-settings.service";
import { NavEntry } from '../../models/project.model';
import { ProgressIndicatorService } from 'src/app/shared/progress-indicator/progress-indicator.service';

import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-navigation-btn-panel',
  templateUrl: './navigation-btn-panel.component.html',
  styleUrls: ['./navigation-btn-panel.component.css']
})
export class NavigationBtnPanelComponent implements OnInit {
  // Subscriptions
  private _subscriptions: Subscription[] = [];

  navEntries: NavEntry[];
  navBtnItems: any[];
  navAdminEntries: NavEntry[];
  navAdminBtnItems: any[];
  appTitle: string = "";

  constructor(private router: Router, private _commonService: CommonService,
    private _appContext: AppContextService, public msalService: MsalService,
    private _progressIndicator: ProgressIndicatorService,
    private _envSetting: EnvSettingsService) {
    this.navEntries = environment.projectNav as NavEntry[];
    this.navAdminEntries = environment.adminNav as NavEntry[];

    this._appContext.storageSetup$.subscribe(res => {
      this.setNavBtnItems();
    });
  }

  ngOnInit() {
    this.setNavBtnItems();

    this._envSetting.getConfig("enableTax");
    

  }
  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }
  private setNavBtnItems(): void {
    let x = this.router.url;
   
    this.navBtnItems = _.map(this.navEntries, ne => {
      let cc = this._commonService.getAppTitle(ne.title);      
      if ((ne.url.includes("tax") && this._envSetting.getConfig("enableTax")) || !ne.url.includes("tax")) {
        const item: any = {
          title: cc,
          icon: ne.icon,
          url: ne.url,
          queryParams: null,
          opensNewTab: false,
          hidden:  !this.router.url.toLowerCase().includes(ne.url)
         
        };

        return item;
      };
    });

    this.navAdminBtnItems = _.map(this.navAdminEntries, ne => {
      const item: any = {
        title: ne.title,
        icon: ne.icon,
        url: ne.url,
        queryParams: null,
        opensNewTab: false,

      };

      return item;
    });
  }

  isCurrentUrl(url) {
    return this.router.url.includes(url);
  }


  navigateToApplication(applicatoinRoute: string) {
    this.router.navigate([`./${applicatoinRoute}/project`]);
  }

  isCurrentMode(url:string,item:any) {
    if (this.router.url!='/' && !this.router.url.includes('/app-error') &&!this.router.url.includes('/copyrights') &&!this.router.url.includes('/admin') && !this.router.url.includes('/access-denied') && !this.router.url.includes('/help')){   
      item.hidden= this.router.url.toLowerCase().includes(url);
      return item.hidden;
    } else {
      item.hidden = url === '/evs' ? true : false;
      return item.hidden;
    }
  }

  logout() {
    this.msalService.logoutRedirect();
  }

  showDisclaimer(){
     //Set Disclaimer message
     localStorage.setItem("termsAccepted", "false");
  }
}
